import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

import {Bubble} from '@deviceinsight/ng-ui-basic-components';
import {TranslationDescriptor} from '@deviceinsight/ng-ui-scale-lib/api';

type Props = {
	label: TranslationDescriptor;
	value: string;
	onChange: (text: string) => void;
	className?: string;
};
export const I18nBubbleContent = (
	<div
		style={{
			maxWidth: 650,
			width: '70vw',
			whiteSpace: 'normal'
		}}>
		<h4>
			<Trans i18nKey="dashboard.widget.help.textInterpolationTitle">Make Text translatable</Trans>
		</h4>
		<strong>##example.key##:</strong>{' '}
		<Trans i18nKey="dashboard.widget.help.translation">
			The translation for the key <strong>example.key</strong>
		</Trans>
		<br />
	</div>
);

const InputWithI18NInfo = ({label, value, onChange, className}: Props) => {
	return (
		<div className={`standard wide field ${className || ''}`}>
			<label>
				<Trans i18nKey={label.id}>{label.defaultValue}</Trans>
				<Bubble content={I18nBubbleContent}>
					<span
						style={{
							cursor: 'pointer',
							color: 'blue'
						}}>
						(?)
					</span>
				</Bubble>
			</label>
			<input type="text" value={value} onChange={(e) => onChange(e.target.value)} />
		</div>
	);
};

export default InputWithI18NInfo;
